/*
 * This contains all the kitchen island messages
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  noKitchenIsland: {
    id: 'cwt.translations.noKitchenIsland',
    defaultMessage: 'No kitchen island',
  },
});
